import React from "react";
import PropTypes from "prop-types";
import { Modal, Button } from "@opendate-app/setlist";
import "../ClassesShared/classesShared.css";

function ClearAttendanceModal({ marksCount, sessionCount, onChoose, onCancel }) {
  const marks = `${marksCount} attendance mark${marksCount === 1 ? "" : "s"}`;
  const question = sessionCount > 1
    ? `These sessions have ${marks}. Moving them to a later date — clear these marks?`
    : `This session has ${marks}. Moving it to a later date — clear these marks?`;

  const footer = (
    <div className="classes-modal-footer">
      <Button variant="tertiary" onClick={onCancel}>Cancel</Button>
      <Button variant="secondary" onClick={() => onChoose(false)}>Keep Marks</Button>
      <Button variant="destructive" onClick={() => onChoose(true)}>Clear Marks</Button>
    </div>
  );

  return (
    <Modal open onClose={onCancel} icon={false} title="Clear attendance marks?" footer={footer}>
      <p className="classes-text-secondary mb-0">
        {question}
      </p>
    </Modal>
  );
}

ClearAttendanceModal.propTypes = {
  marksCount: PropTypes.number.isRequired,
  sessionCount: PropTypes.number.isRequired,
  onChoose: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ClearAttendanceModal;
